import React from "react";
import SearchByUserAndDate from "../../components/common/SearchByUserAndDate";
import "../../styles/css/VisitUserMap.css";
import MapVisitUser from "./MapVisitUser";
import Axios from "axios";
import * as Constants from "../../consts/Constants.js";

const Visits = () => {
  const [mapData, setMapData] = React.useState([]);

  const onSearch = (userId, date) => {
    Axios.get(
      Constants.FINAL_URL_TRACE_USER_DATE + "/" + userId + "/" + date
    ).then((response) => {
      let data = response.data;
      setMapData(data);
    });
  };

  return (
    <div className="visitUserMap">
      <div className="map">
        <MapVisitUser data={mapData} />
      </div>
      <div className="search">
        <SearchByUserAndDate title="Buscar estadias" onSearch={onSearch} />
      </div>
    </div>
  );
};

export default Visits;
